'use client';

import { c as _c } from "react/compiler-runtime";
import { Award, Files, GitCommitVertical, LayoutDashboard, ListChecks, MessageSquare, PackageCheck, Receipt, type LucideIcon } from 'lucide-react';
import type { ArbitralDetailTab } from '../../types/arbitralDetailTypes';
interface ArbitralDetailTabsProps {
  activeTab: ArbitralDetailTab;
  onTabChange: (value: string) => void;
  pendenciasAtivasCount: number;
  totalMensagensNaoLidas: number;
  totalCertificados: number;
  cobrancasEmAbertoCount?: number;
  temCobrancaVencida?: boolean;
  abasOcultas?: ArbitralDetailTab[];
  mostrarEnvioFisicoAr?: boolean;
}
interface TabConfig {
  value: ArbitralDetailTab;
  label: string;
  icon: LucideIcon;
  count?: number;
  countVariant?: 'neutral' | 'warning' | 'error';
}
export function ArbitralDetailTabs(t0) {
  const $ = _c(14);
  const {
    activeTab,
    onTabChange,
    pendenciasAtivasCount,
    totalMensagensNaoLidas,
    totalCertificados,
    cobrancasEmAbertoCount: t1,
    temCobrancaVencida: t2,
    abasOcultas: t3,
    mostrarEnvioFisicoAr: t4
  } = t0;
  const cobrancasEmAbertoCount = t1 === undefined ? 0 : t1;
  const temCobrancaVencida = t2 === undefined ? false : t2;
  let t5;
  if ($[0] !== t3) {
    t5 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const abasOcultas = t5;
  const mostrarEnvioFisicoAr = t4 === undefined ? false : t4;
  let t6;
  if ($[2] !== abasOcultas || $[3] !== cobrancasEmAbertoCount || $[4] !== mostrarEnvioFisicoAr || $[5] !== pendenciasAtivasCount || $[6] !== temCobrancaVencida || $[7] !== totalCertificados || $[8] !== totalMensagensNaoLidas) {
    const todasAsAbas = [{
      value: "resumo",
      label: "Vis\xE3o geral",
      icon: LayoutDashboard
    }, {
      value: "andamentos",
      label: "Andamentos",
      icon: GitCommitVertical
    }, {
      value: "pendencias",
      label: "Pend\xEAncias",
      icon: ListChecks,
      count: pendenciasAtivasCount || undefined,
      countVariant: "warning"
    }, {
      value: "documentos",
      label: "Documentos",
      icon: Files
    }, {
      value: "envio-fisico",
      label: "Envio f\xEDsico",
      icon: PackageCheck
    }, {
      value: "financeiro",
      label: "Financeiro",
      icon: Receipt,
      count: cobrancasEmAbertoCount || undefined,
      countVariant: temCobrancaVencida ? "error" : "warning"
    }, {
      value: "certificados",
      label: "Certificados",
      icon: Award,
      count: totalCertificados || undefined
    }, {
      value: "chat",
      label: "Chat",
      icon: MessageSquare,
      count: totalMensagensNaoLidas || undefined,
      countVariant: "error"
    }];
    t6 = todasAsAbas.filter(tab => !abasOcultas.includes(tab.value) && (tab.value !== "envio-fisico" || mostrarEnvioFisicoAr));
    $[2] = abasOcultas;
    $[3] = cobrancasEmAbertoCount;
    $[4] = mostrarEnvioFisicoAr;
    $[5] = pendenciasAtivasCount;
    $[6] = temCobrancaVencida;
    $[7] = totalCertificados;
    $[8] = totalMensagensNaoLidas;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const tabs = t6;
  let t7;
  if ($[10] !== activeTab || $[11] !== onTabChange || $[12] !== tabs) {
    t7 = <div className="bg-default-background flex flex-wrap items-center gap-1 rounded-[16px] border border-solid border-neutral-200 p-1.5 shadow-sm">{tabs.map(tab_0 => {
        const Icon = tab_0.icon;
        const ativo = activeTab === tab_0.value;
        const contadorClasse = tab_0.countVariant === "warning" ? "bg-warning-100 text-warning-700" : tab_0.countVariant === "error" ? "bg-error-100 text-error-700" : "bg-neutral-200 text-neutral-600";
        return <button key={tab_0.value} type="button" onClick={() => onTabChange(tab_0.value)} className={`inline-flex h-10 items-center justify-center gap-2 rounded-[8px] px-3.5 text-sm font-medium whitespace-nowrap transition ${ativo ? "bg-brand-600 text-white" : "text-neutral-600 hover:bg-neutral-100"}`}><Icon size={16} />{tab_0.label}{typeof tab_0.count === "number" ? <span className={`rounded-md px-1.5 py-0.5 text-[11px] font-semibold tabular-nums ${ativo ? "bg-white/20 text-white" : contadorClasse}`}>{tab_0.count}</span> : null}</button>;
      })}</div>;
    $[10] = activeTab;
    $[11] = onTabChange;
    $[12] = tabs;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}